import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class TransloadOrders_ds_get_child_lps_by_parent_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { parent_id: number }): 
  Promise<{ result: { Id?: number, ParentId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.parent_id)) {
      missingRequiredInParams.push('\'parent_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { parent_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ParentId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.parent_id)) {
      missingRequiredInParams.push('\'parent_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { parent_id: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ParentId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.parent_id)) {
      missingRequiredInParams.push('\'parent_id\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      parent_id: number    }) {
        if(isNil(inParams.parent_id)) {
          return true; 
        }
      return false;
    }
}
